import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'local-seo-delta',
  imports: [CommonModule, MatIconModule],
  templateUrl: './delta.component.html',
  styleUrls: ['./delta.component.scss'],
})
export class DeltaComponent {
  @Input() value: number;
  @Input() showNeutral = false;

  absVal(value: number) {
    return Math.abs(value);
  }
}
